import React, { useEffect } from "react";
import EmailCaptureOverlay from "web/react/components/email-capture-overlay/email-capture-overlay";
import GenericModal from "web/react/components/generic-modal/generic-modal";
import MemberBenefitsCarousel from "web/react/components/member-benefits-carousel/member-benefits-carousel";
import analytics from "web/script/analytics/analytics";
import { closeCustomerCaptureOverlay } from "web/redux/ducks/customer-capture-overlay";
import { connect } from "react-redux";
import { gettext } from "web/script/modules/django-i18n";
import withReduxProvider from "web/react/redux-provider";
import environment from "web/script/modules/environment";
import globals from "web/script/modules/globals";
import styles from "./email-capture-overlay-membership-benefits.css";

interface EmailCaptureOverlayMembershipBenefitsProps {
    captureType: string;
    overlayOpen: boolean;
    privacyPolicyLink: string;
    termsAndConditionsLink: string;
    cookiePolicyLink: string;
    signInLink: string;
    shortPolicy: boolean;
    next: string;
    closeCustomerCaptureOverlay: () => void;
}

export function EmailCaptureOverlayMembershipBenefits({
    captureType,
    overlayOpen,
    privacyPolicyLink,
    termsAndConditionsLink,
    cookiePolicyLink,
    signInLink,
    shortPolicy,
    next,
    closeCustomerCaptureOverlay,
}: EmailCaptureOverlayMembershipBenefitsProps): JSX.Element {
    const blockVariant = environment.getFeature("mg_android_block_is_pdp_related_product_card");
    let fullProductUrl;

    if (next) {
        try {
            fullProductUrl = new URL(next, globals.window.location.href);
        } catch (err) {
            console.error(`${next} is not a valid URL`);
        }
    }

    function onClose(): void {
        analytics.event(captureType, "close_signup_form", "exit_signup");
        closeCustomerCaptureOverlay();
        if (blockVariant === "soft_block" && fullProductUrl) {
            globals.window.location.href = fullProductUrl.href;
        }
    }

    useEffect(() => {
        if (overlayOpen) {
            analytics.event(captureType, "open_signup_form", "open_overlay");
        }
    }, [overlayOpen, captureType]);

    return (
        <GenericModal isOpen={overlayOpen} onClose={onClose}>
            <div className={styles.overlayContainer}>
                <h3 className={styles.title}>{gettext("member_signup.member_overlay.title_1")}</h3>
                <MemberBenefitsCarousel />
                <EmailCaptureOverlay
                    contentOnly={true}
                    autoFocus={false}
                    cookiePolicyLink={cookiePolicyLink}
                    privacyPolicyLink={privacyPolicyLink}
                    termsAndConditionsLink={termsAndConditionsLink}
                    shortPolicy={shortPolicy}
                    signInLink={signInLink}
                />
            </div>
        </GenericModal>
    );
}

export default withReduxProvider(
    connect(null, { closeCustomerCaptureOverlay })(EmailCaptureOverlayMembershipBenefits)
);
